import { Box, Dialog, Portal, CloseButton } from "@chakra-ui/react"

// The abstract a presentation's `abstract` link points to, in a modal. The link's URL (Call for
// Science) serves a complete styled HTML document, so it is rendered in an iframe: its global
// styles (body, h1, *) stay out of the page, and the sandbox keeps its scripts from running while
// still letting links inside it open in a new tab. Shared by the program guide (SessionDetail) and
// the chatbot's session cards (InlineSessionCard).
export function findAbstractLink(links) {
    return Array.isArray(links) ? links.find(link => link?.type === "abstract" && link?.url) || null : null
}

export default function AbstractModal({ open, onClose, url, title }) {
    return (
        <Dialog.Root
            open={open}
            onOpenChange={({ open }) => !open && onClose()}
            size="xl"
            placement="center"
            scrollBehavior="inside"
        >
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content h="85vh" overflow="hidden" aria-label={title}>
                        <Dialog.Body p={0} display="flex">
                            {open && url && (
                                <Box
                                    as="iframe"
                                    src={url}
                                    title={title || "Abstract"}
                                    sandbox="allow-popups allow-popups-to-escape-sandbox"
                                    flex="1"
                                    w="100%"
                                    border={0}
                                />
                            )}
                        </Dialog.Body>
                        {/* The abstract scrolls inside the iframe, so the button stays put in the
                            corner; the white circle keeps it legible over the abstract's page. */}
                        <Dialog.CloseTrigger asChild top={3} insetEnd={3} zIndex={1}>
                            <CloseButton
                                size="sm"
                                bg="white"
                                color="gray.700"
                                borderRadius="full"
                                boxShadow="md"
                                _hover={{ bg: "gray.100" }}
                            />
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    )
}
